import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import MarkdownToHtml from '../../components/MarkdownToHtml';

const MdToHtmlPage: React.FC = () => (
  <ToolLayout
    title="Markdown to HTML Converter | AllTools"
    description="Convert Markdown to HTML with live preview. Supports headings, bold, links, code blocks, tables. Free tool."
    canonicalPath="/markdown-to-html"
  >
    <MarkdownToHtml />
  </ToolLayout>
);

export default MdToHtmlPage;
